// Libraries
import { Center, Flex, Text } from '@chakra-ui/react';
// Components
import { RatingsIcon } from '@atoms/index';
// Utils
import text from '@translations/en.json';
// Types
import { OptimizeAlertProps } from './OptimizeAlert.types';

/**
 * Displays an optimization alert message based on the provided rating.
 * The alert highlights any potential discrepancies or recommendations in the rating.
 * If the rating value is `true` or unset, the component doesn't render any alert.
 *
 * @component
 * @param {OptimizeAlertProps} props - The props for the OptimizeAlert component.
 * @param {RatingKeys | boolean} props.rating - The rating value used to determine the alert message. Can be a string representing the rating or a boolean value.
 *
 * @returns {ReactElement | null} The OptimizeAlert component, or null if no alert should be displayed.
 */
export const OptimizeAlert = ({ rating }: OptimizeAlertProps) => {
  const showAlert = !!rating && rating !== true;
  return showAlert ? (
    <Flex bg={`ratings.${rating}.light`} w='fit-content' gap={1} py={1} px={2} borderRadius='base'>
      <Text as='span' fontSize='s'>
        {text.cii_simulator.rating_simulation_card.optimize_message}
      </Text>
      <Center as='span'>
        <RatingsIcon dark rating={rating} boxSize={3.5} />
      </Center>
      <Text as='span' fontSize='s'>
        {text.cii_rating}.
      </Text>
    </Flex>
  ) : null;
};
